const zendeskScriptId = "ze-snippet";
export const initializeZendeskSDK = (key: string, onLoad: () => void) => {
  // Skip if running on server
  if (typeof window === "undefined") return;

  // Skip if already initialized
  if (window.zE) {
    onLoad();
    return;
  }

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  script.id = zendeskScriptId;
  script.onload = onLoad;

  script.src = `https://static.zdassets.com/ekr/snippet.js?key=${key}`;

  document.head.appendChild(script);
};

export const destroyZendeskSDK = () => {
  window.zE?.("messenger", "hide");
  window.zE?.("messenger", "logoutUser");
  window.zE = undefined;
  window.zEmbed = undefined;
  window.zEACLoaded = undefined;
  window.zEWebpackACJsonp = undefined;
  document.getElementById(zendeskScriptId)?.remove();
};
